// @flow
import React from 'react';
import NewProductLayout from '../../common/new-product-layout/NewProductLayoutComponent';
import ProductSizeSelectionComponent from '../product-size/ProductSizeSelectionComponent';
import ProductElementSelectionComponent from '../product-element/ProductElementSelectionComponent';
import LoadingComponent from '../../../common/loading/LoadingComponent';
import {
  isValidProductTypeRoute,
  isValidProductSizeRoute,
  getProductIdByRoute,
} from '../../../services/products-route/ProductsRouteService';
import { envUrl } from '../../../services/environment/EnvironmentService';
import { pushLocationAction } from '../../../core/actions/routing/RoutingActions';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import productEvents from '../../../../analytics/events/products';

type Props = {
  parentLocation: string | null,
  match: Object,
  config: Object,
  history: Object,
};

class FullUploadProductCustomisationComponent extends React.Component<Props> {
  constructor(props: Props): void {
    super(props);

    this.state = {
      productTypeId: getProductIdByRoute(props.match.params.type) || null,
    };
  }

  UNSAFE_componentWillMount(): void {
    this.redirectToValidUrl();
  }

  redirectToValidUrl(): void {
    const { type } = this.props.match.params;
    const { size } = this.props.match.params;

    if (type) {
      const isValidProductType = isValidProductTypeRoute(type);

      // Don't re-render the Size Selection if invalid URL
      if (!isValidProductType) {
        const backToProductSelection = pushLocationAction({ pathname: envUrl('/products/upload') });
        this.props.history.transitionTo(backToProductSelection);
        return;
      }

      // Don't re-render the Element Selection if invalid URL
      if (size) {
        const isValidProductSize = isValidProductSizeRoute(this.state.productTypeId, size);

        if (!isValidProductSize) {
          const backToSizeSelection = pushLocationAction({ pathname: envUrl(`/products/upload/${type}`) });
          this.props.history.transitionTo(backToSizeSelection);
        }
      }
    }
  }

  hasProductTypeRoute() {
    const { type, size } = this.props.match.params;
    return type && isValidProductTypeRoute(type) && !size;
  }

  hasProductSizeRoute() {
    const { size } = this.props.match.params;
    return size && isValidProductSizeRoute(this.state.productTypeId, size);
  }

  renderCustomizationOptions() {
    const { config, match } = this.props;

    if (this.hasProductTypeRoute()) {
      return (
        <ProductSizeSelectionComponent
          config={config}
          params={match.params}
          guidelinesCallback={() => AnalyticsClient.trackEvent(productEvents.guidelinesNewProduct())}
          sizeSelectionCallback={(size: string) => AnalyticsClient.trackEvent(productEvents.sizeNewProduct(size))}
        />
      );
    }
    if (this.hasProductSizeRoute()) {
      return (
        <ProductElementSelectionComponent
          config={config}
          params={match.params}
          guidelinesCallback={() => AnalyticsClient.trackEvent(productEvents.guidelinesNewProduct())}
          elementSelectionCallback={(element: string) =>
            AnalyticsClient.trackEvent(productEvents.elementNewProduct(element))
          }
        />
      );
    }
    return <LoadingComponent />;
  }

  render(): Element {
    return (
      <NewProductLayout
        parentLocation={this.props.parentLocation}
        onBackCallback={() => AnalyticsClient.trackEvent(productEvents.backButtonNewProduct())}
        onCloseCallback={() => AnalyticsClient.trackEvent(productEvents.closeButtonNewProduct())}
      >
        {this.renderCustomizationOptions()}
      </NewProductLayout>
    );
  }
}

FullUploadProductCustomisationComponent.displayName = 'FullUploadProductCustomisationComponent';

FullUploadProductCustomisationComponent.defaultProps = {
  parentLocation: null,
};

export default FullUploadProductCustomisationComponent;
